import { wrapper, createApiClient, Result, ApiError } from "../base";
import NavigationGroupDO = App.Data.NavigationGroupDO;

const basePath = `navigation`;
const baseClient = createApiClient();

export default class {
	getNavigation(): Promise<Result<NavigationGroupDO[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}`));
	}
}
